import Subtitle from "../../Subtitle";
import Title from "../../Title";
import servicestars from '@/assets/images/ASCII/Group 199.png';
import AsciiArt from "../../AsciiArt";
import BasicText from "../../BasicText";
import asciihand from '@/assets/images/ASCII/Group 174.png';
import DotEffect from "../../svg/DotEffect";
import BigEllipse from "../../svg/ellipse/BigEllipse";
import asciiscroll from '@/assets/images/ASCII/Group 204.png';
import asciicoins from '@/assets/images/ASCII/Group 203.png';
import asciibags from '@/assets/images/ASCII/Group 202.png';

function OurServices({ ref0 }: any) {
  return (
    <div ref={ref0} className="relative flex flex-col gap-[10px] items-start justify-start w-full xl:w-[1200px] px-4 sm:px-10 md:px-11 lg:px-12 xl:px-0">
      <div className="h-[500px] flex flex-col items-start justify-center">
        <Subtitle>
        // Our services
        </Subtitle>
        <Title>
          <div className="flex flex-col items-start text-[25px]">
            <div>Luminode is much more than</div>
            <div className="flex flex-row">just a&nbsp;<div className="text-luminode-blue">Development Agency.</div></div>
          </div>
        </Title>
      </div>
      <div className="absolute top-[-90px] right-[-130px] opacity-30 xl:opacity-100">
        <AsciiArt src={servicestars} />
      </div>
      <div className="absolute top-[-17px] left-[-130px] pointer-events-none">
        <DotEffect />
      </div>
      <div className="absolute top-[-230px] right-[-800px] pointer-events-none">
        <BigEllipse />
      </div>
      <div className="absolute top-[300px] right-[100px] pointer-events-none">
        <BigEllipse />
      </div>

      <div className="w-full">
        <div className="flex flex-row w-full pb-[32px]">
          <div>
            <BasicText color="faded">
              <div className="opacity-50 pb-[12px]">
                // 01
              </div>
            </BasicText>
            <Title>
              <div className="text-[24px] pb-[20px] tracking-normal">
                SaaS Contracting
              </div>
            </Title>
            <BasicText color="faded">
              <div className="opacity-60 max-w-[630px]">
                <div>We execute both onchain and offchain development on behalf
                  of web2/web3 companies, ranging in size from startups to 9
                  figure corporations.</div>

                <div className="pt-[20px]">With experience managing 7-9 figure budgets, we are able
                  to complete projects of any size with both efficiency and
                  quality.</div>
              </div>
            </BasicText>
          </div>
          {/* Sits above the sparkles' transparent padding so the scroll gets its own hover. */}
          <div className="hidden grow xl:flex justify-center items-center h-full relative z-10">
            <AsciiArt src={asciiscroll} />
          </div>
        </div>
      </div>
      <div className="w-full">
        <div className="flex flex-row w-full pb-[32px]">
          <div className="hidden grow xl:flex justify-center items-center h-full">
            <AsciiArt src={asciicoins} />
          </div>
          <div>
            <BasicText color="faded">
              <div className="opacity-50 pb-[12px] relative">
                // 02
              </div>
            </BasicText>
            <Title>
              <div className="text-[24px] pb-[20px] tracking-normal relative">
                Market Research
              </div>
            </Title>
            <BasicText color="faded">
              <div className="opacity-60 max-w-[630px]">
                <div className="">With multi cycle experience dating back to 2011-2012, we are active market participants focused on keeping our ear to the chain at all times in order to accurately know how to provide the best UX possible. As well as to identify solutions that may be vital to scaling our industry forward.</div>
              </div>
            </BasicText>
          </div>
        </div>

      </div>
      <div className="w-full">
        <div className="flex flex-row w-full pb-[32px]">
          <div>
            <BasicText color="faded">
              <div className="opacity-50 pb-[12px]">
                // 03
              </div>
            </BasicText>
            <Title>
              <div className="text-[24px] pb-[20px] tracking-normal">
                Venture IP
              </div>
            </Title>
            <BasicText color="faded">
              <div className="opacity-60 max-w-[630px]">
                <div className="pb-[20px]">Using our extensive market experience, we are building out products under the Luminode corporate umbrella, as well as taking an ownership position in projects that we see potential in.</div>
              </div>
            </BasicText>
          </div>
          <div className="hidden grow xl:flex justify-center items-center h-full relative">
            <AsciiArt src={asciibags} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default OurServices;